import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { DocumentFormCard } from './DocumentFormCard';
import CardMessages from '../../messages-notifications/messages/to-refactor/card/CardMessages';
import bindActionCreators from 'redux/es/bindActionCreators';
import { connect } from 'react-redux';
import * as documentFormActions from '../actions/documentFormActions';
import Row from '../../shared/components/Row';
import DocumentRevisionsCard from '../components/DocumentRevisionsCard';
import WorkerInfoCard from '../../worker/components/WorkerInfoCard';
import MachineInfoCard from '../../machines/components/MachineInfoCard';
import OutsourceInfoCard from '../../outsource/components/OutsourceInfoCard';
import { CurrentUser } from '../../shared/model/CurrentUser';

class DocumentDetail extends React.Component {

    constructor(init) {
        super(init);

        this.state = {
            getInfoComplement: false,
        };
    }

    componentWillMount() {
        this.props.documentFormActions.getDocument(this.props.documentId);
    }

    componentDidUpdate(prevProps, prevState) {
        if ( this.props.document !== prevProps.document ) {
            this.props.appendBreadcrumb(this.props.document);
            this.getInfoComplement();
        }
    }

    componentWillUnmount() {
        this.props.documentFormActions.clearDocument();
    }

    getInfoComplement() {
        const { document, documentFormActions } = this.props;
        const { getInfoComplement } = this.state;

        if ( document && !getInfoComplement ) {
            if ( document.worker ) {
                documentFormActions.getDocumentWorker(document.worker.id);
            } else if ( document.machine ) {
                documentFormActions.getDocumentMachine(document.machine.id);
            } else if ( document.company ) {
                documentFormActions.getDocumentCompany(document.company.id);
            }
            this.setState({ getInfoComplement: true });
        }
    }

    renderDocumentInfoComplement() {
        const {
            document: {
                worker,
                machine,
                company,
            },
        } = this.props;

        if ( worker ) {
            return (
                <WorkerInfoCard worker={worker}/>
            );
        }

        if ( machine ) {
            return (
                <MachineInfoCard machine={machine}/>
            );
        }

        if ( company ) {
            return (
                <OutsourceInfoCard outsource={company}/>
            );
        }
    }

    render() {
        const {
            message,
            document,
            currentUser,
        } = this.props;

        if ( !currentUser.hasRole() ) return null;

        if ( message !== null ) {
            return (
                <h3 className={'text-center'}>{message}</h3>
            );
        }

        if ( !document ) return null;

        return (
            <React.Fragment>
                {
                    this.renderDocumentInfoComplement()
                }
                <DocumentFormCard
                    document={document}
                    allowUpload={!currentUser.isOutsourcesViewer()}
                />
                <Row>
                    <div className="col-md-6 col-lg-7">
                        <DocumentRevisionsCard
                            documentId={document.id}
                            title={I18nUtils.tr('TR_REVISIONS')}
                        />
                    </div>
                    <CardMessages
                        documentId={document.id}
                        colWidth={'col-md-6 col-lg-5'}
                        canAddMessage={currentUser.isAdmin() || currentUser.isOutsourcesManager()}
                        canResponseMessage={currentUser.isAdmin() || currentUser.isOutsourcesManager()}
                    />
                </Row>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        document: state.formDocument.document,
        message: state.formDocument.message,
        currentUser: CurrentUser.fromReduxState(state),
    };
};

const mapDispatchToProps = dispatch => ( {
    documentFormActions: bindActionCreators(documentFormActions, dispatch),
} );

export const DocumentDetailContent = connect(mapStateToProps, mapDispatchToProps)(DocumentDetail);

DocumentDetailContent.propTypes = {
    documentId: PropTypes.string.isRequired,
    appendBreadcrumb: PropTypes.func.isRequired,
};

DocumentDetailContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/DocumentDetailContent.jsx